import { createStyles } from '../../../../../../../../styles/helpers'

const useStyles = createStyles(theme => ({
  customise: {
    color: theme.brandPrimary,
    textDecoration: 'underline',
    cursor: 'pointer'
  }
}))

export default useStyles
